import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useAuthContext } from '../context';
import { Spinner } from '@lib/ui';
import { HOME_PATH, REDIRECT_URL_KEY } from '@/constants/app';

export function AuthCallback() {
  const navigate = useNavigate();
  const { isAuthenticated, isLoading } = useAuthContext();

  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      const redirectUrl = new URLSearchParams(window.location.search).get(REDIRECT_URL_KEY);
      navigate(redirectUrl || HOME_PATH, { replace: true });
    }
  }, [isLoading, isAuthenticated, navigate]);

  return (
    <div className="flex h-screen w-full items-center justify-center bg-gray-50 dark:bg-dark-900">
      <div className="flex flex-col items-center gap-4">
        <Spinner size="md" />
        <p className="text-sm text-gray-500 dark:text-dark-300">Completing sign in...</p>
      </div>
    </div>
  );
}
